import { call } from "redux-saga/effects";
import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";

import flagger from "../../decorators/flagger.decorator";
import { Flaggers } from "../../store/flaggers/flaggers.enum";
import { BASE_API_PAGE_ENUMS } from "../../../constants/apis.constants";
import { ReducerMethods } from "../../store/reducer.methods";
import type RemovePortlandReportDto from "./dto/remove-portland-report.dto";
import { CallToast } from "../../../Components/PriceCalculator/modals/CustomToast";

export const PortlandReportEffectActions = {
  removePortlandReport: `${Entities.PortlandReport}_removePortlandReport`,
};

const initSchema: InitSchemaReducer = {
  definitions: {  },
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.PortlandReport,
  initSchema,
  aliasName: DIContainerKeys.PortlandReportService,
})
export class PortlandReportService extends HttpService {
  @flagger(Flaggers.RemovePortlandReportFlagger)
  @action(DIContainerKeys.PortlandReportService)
  public *removePortlandReport(dto: RemovePortlandReportDto): Generator<any, void, any> {
    yield this.setFlaggerState(Flaggers.RemovePortlandReportFlagger, { isLoading: true, reportId: dto.reportId, show: true });
    const response = yield call(
      this.get,
      {
        url: this.pageEnum(BASE_API_PAGE_ENUMS.removePortlandReport),
        params: {
          optionEnum1: dto.reportId,
          optionEnum2: 0
        }
      },
      ReducerMethods.UPDATE
    );
    if (!response?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setFlaggerState(Flaggers.RemovePortlandReportFlagger, { isLoading: false, reportId: dto.reportId, show: true });
      return;
    }
    yield this.setFlaggerState(Flaggers.RemovePortlandReportFlagger, null);
    CallToast("Report removed successfully", true, false, "v2style");
    if (dto.callBack) {
      dto.callBack(dto.reportId);
    }
  }
}